module.exports = "<div class=\"login\">\r\n\r\n    <mms-banner banner-label=\"Sign in\"></mms-banner>\r\n\r\n    <login-form email-address=\"$ctrl.email\" on-login=\"$ctrl.onLogin()\"></login-form>\r\n\r\n    <mms-footer></mms-footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.html
// module id = 678
// module chunks = 0